import { useQuery } from '@tanstack/react-query';
import { type ComponentProps, type FC } from 'react';

import { useDebounce } from '@/hooks/useDebounce';
import { queries } from '@/queries';

import TextInputWithSuggestions from '../Form/Fields/TextInputWithSuggestions';

type Props = Omit<
  ComponentProps<typeof TextInputWithSuggestions>,
  'suggestions'
>;

const SearchInput: FC<Props> = ({ inputProps, onSelectSuggestion }) => {
  const debouncedSearch = useDebounce(inputProps.value?.toString() ?? '');

  const { data: searchSuggestionData, isFetching } = useQuery({
    ...queries.externalOffers.suggestedSearch('JOB_TITLE', debouncedSearch),
    enabled: !!debouncedSearch && debouncedSearch.length > 0,
    keepPreviousData: true,
  });

  const isLoading = isFetching || inputProps.value !== debouncedSearch;

  return (
    <TextInputWithSuggestions
      inputProps={inputProps}
      onSelectSuggestion={onSelectSuggestion}
      suggestions={searchSuggestionData}
      isLoading={isLoading}
    />
  );
};

export default SearchInput;
